import { render, staticRenderFns } from "./QScoreCardConservedPolicies.vue?vue&type=template&id=66861b46&scoped=true&"
import script from "./QScoreCardConservedPolicies.vue?vue&type=script&lang=js&"
export * from "./QScoreCardConservedPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66861b46",
  null
  
)

export default component.exports